import { type RequestStatus } from 'core/domain/Request'

import { TokenExpiredError } from 'auth/errors/TokenExpiredError'
import { UnauthorizedInviteError } from 'auth/errors/UnauthorizedInviteError'

import { ErrorState } from './ErrorState'
import { ExpiredInviteState } from './ExpiredInviteState'
import { UnauthorizedInviteState } from './UnauthorizedInviteState'

type ProposalPageErrorStateProps = {
  error?: unknown
  emailRecipient?: string
  refreshInviteTokenStatus: RequestStatus
}

export function ProposalPageErrorState({
  error,
  emailRecipient,
  refreshInviteTokenStatus,
}: ProposalPageErrorStateProps) {
  if (error instanceof TokenExpiredError) {
    return (
      <ExpiredInviteState
        emailRecipient={emailRecipient}
        refreshInviteTokenStatus={refreshInviteTokenStatus}
      />
    )
  }

  if (error instanceof UnauthorizedInviteError) {
    return <UnauthorizedInviteState />
  }

  return <ErrorState />
}
